import React from "react";
import Modal from "react-modal";
import InputBox from "./InputBox";
import _ from "lodash";
import "../css/SystemIntegratorAdd.css";
import ErrorText from "../ErrorText";
import cities from "./cities";
import Loader from "./Loader";
import SnackBar from "./SnackBar";
import { MenuItem, TextField } from "@mui/material";
import Indflag from "../assets/images/indian_flag.png";
import Africaflaf from "../assets/images/south-africa.png";
import Ausflag from "../assets/images/aus-flag.png";
import UAEflag from "../assets/images/united-arab-emirates.png";

// Distributor page to add new Distributor page

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "90%",
    overflow: "auto",
    padding: "40px 90px 40px 90px",
    marginLeft: "260px",
    marginTop: "3%",
    backgroundColor: "#EFF3F6",
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const customStylesSuccess = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "90%",
    overflow: "auto",
    padding: "40px 90px 40px 90px",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const SiRating = [{ label: "A++" }, { label: "A" }, { label: "B+" }];

const SiRelationStat = [
  { label: "Hot" },
  { label: "Warm" },
  { label: "Dry" },
  { label: "Cold" },
];

const distributorCountry = [
  { imageSrc: Ausflag, label: "Australia" },
  { imageSrc: Africaflaf, label: "Africa" },
  { imageSrc: UAEflag, label: "UAE" },
  { imageSrc: Indflag, label: "India" },
];

export default class DistributorAddNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: "animated animated-duration-custom slideInDown",
      modalStateAftereOpenSuccess:
        "animated animated-duration-custom slideInDown",
      noOfParams: [],
      // SiUsername: '',
      SiUsername: "",
      SiCompany: "",
      SiName: "",
      SiEmail: "",
      SiMobile: "",
      SiArea: "",
      DistributorCountry: "",
      SiAddress: "",
      errorMessage: [],
      modalIsOpenSuccess: false,
      showErrorMessage: false,
      usernameAvailable: true,
      siData: [],
      indianCityWithState: [],
      loader: false,
      SiGST: "",
      snackbarActive: false,
      snackbarMessage: "",
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModalSuccess() {
    this.setState(
      {
        modalStateAftereOpenSuccess:
          "animated animated-duration-custom slideOutUp",
        modalIsOpen: false,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpenSuccess: false,
            },
            () => this.props.closeAllModal(),
          );
        }, 500);
      },
    );
  }

  afterOpenModal() {}

  closeModal() {
    this.setState(
      {
        modalStateAftereOpen: "animated animated-duration-custom slideOutUp",
        SiUsername: "",
        SiCompany: "",
        SiName: "",
        SiEmail: "",
        SiMobile: "",
        SiArea: "",
        DistributorCountry: "",
        SiAddress: "",
        siGST: "",
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpen: false,
            },
            () => this.props.closeAllModal(),
          );
        }, 500);
      },
    );
  }

  onSelectChange = (operationMode, valueSelect) => {
    //console.log(valueSelect, operationMode)
    if (operationMode === "rating") {
      this.setState({
        SiRating: valueSelect.value,
        errorMessage: [],
      });
    }
    if (operationMode === "relationStat") {
      this.setState({
        SiRelationStat: valueSelect.value,
        errorMessage: [],
      });
    }
    // if (operationMode === 'distributorCountry') {
    //   this.setState({
    //     DistributorCountry: valueSelect,
    //     errorMessage: []
    //   })
    // }

    if (operationMode === "distributorCountry") {
      const isIndia = valueSelect === "India";
      this.setState({
        DistributorCountry: valueSelect,
        showIndiaFields: isIndia,
        SiArea: isIndia ? this.state.SiArea : "",
        SiGST: isIndia ? this.state.SiGST : "",
        errorMessage: [],
      });
    }

    if (operationMode === "siArea") {
      this.setState(
        {
          SiArea: valueSelect,
          errorMessage: [],
        },
        () => {},
      );
    }
  };

  componentDidMount() {
    this.fecthAllDistributor();
    let cityNew = [];
    cities.map((e) => {
      let newCity = {
        label: `${e.city}, ${e.state}`,
      };
      cityNew.push(newCity);
    });
    this.setState(
      {
        indianCityWithState: cityNew,
      },
      () => console.log(this.state.indianCityWithState),
    );
  }

  fecthAllDistributor = () => {
    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };
    fetch("/cloud/distributors/", {
      // Change to Distributor
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          siData: data.data,
        });
        // console.log(data.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  AddingDistributor = () => {
    let si_name = this.state.SiName;
    let si_company = this.state.SiCompany;
    let si_email = this.state.SiEmail;
    let si_mobile = this.state.SiMobile;
    let si_area = this.state.SiArea;
    let si_address = this.state.SiAddress;
    let si_gstin = this.state.SiGST;
    let si_country = this.state.DistributorCountry;

    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };

    fetch("/cloud/distributors/", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_name,
        si_email,
        si_mobile,
        si_area,
        si_address,
        si_company,
        si_country,
        si_gstin,
      }),
    })
      .then(async (response) => {
        const data = await response.json();

        // ❌ If API returns 400 or any error status
        if (!response.ok) {
          alert(data.message || "Something went wrong");
          this.setState({ loader: false });
          throw new Error(data.message);
        }

        return data;
      })
      .then((data) => {
        // ✅ success case only
        this.setState(
          {
            modalIsOpen: false,
            modalIsOpenSuccess: true,
            loader: false,
          },
          () => this.fecthAllDistributor(),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  AddingAnotherDistributor = () => {
  let si_name = this.state.SiName;
  let si_email = this.state.SiEmail;
  let si_mobile = this.state.SiMobile;
  let si_area = this.state.SiArea;
  let si_address = this.state.SiAddress;
  let si_company = this.state.SiCompany;
  let si_country = this.state.DistributorCountry;
  let si_gstin = this.state.SiGST;

  var tokenStored = localStorage.getItem("token");
  tokenStored = `Token ${tokenStored}`;

  var headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "X-CSRFToken": localStorage.getItem("csrftoken"),
    Authorization: tokenStored,
  };

  fetch("/cloud/distributors/", {
    method: "POST",
    headers: headers,
    body: JSON.stringify({
      si_name,
      si_email,
      si_mobile,
      si_area,
      si_address,
      si_company,
      si_gstin,
      si_country,
    }),
  })
    .then(async (response) => {

      // 🔐 Session expired
      if (response.status === 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("csrftoken");
        localStorage.removeItem("auth");
        window.location.href = "/session-timeout";
        return;
      }

      const data = await response.json();

      // ❌ Handle 400 error → show alert only
      if (response.status === 400) {
        alert(data.message || "Invalid data");
        this.setState({ loader: false });
        throw new Error(data.message);
      }

      // ❌ Any other error
      if (!response.ok) {
        alert("Something went wrong");
        this.setState({ loader: false });
        throw new Error("API error");
      }

      // ✅ success only
      return data;
    })
    .then((data) => {
      if (!data) return;

      this.setState(
        {
          modalIsOpen: false,
          addAnotherSuccess: true,
          siData: data,
        },
        () => {
          setTimeout(() => {
            this.setState({ addAnotherSuccess: false });
          }, 3000);

          this.setState(
            {
              modalIsOpen: true,
              SiName: "",
              SiCompany: "",
              SiGST: "",
              SiEmail: "",
              SiMobile: "",
              SiArea: "",
              SiAddress: "",
              DistributorCountry: "",
              showErrorMessage: false,
              DistributorGST: "",
              loader: false,
            },
            () => this.fecthAllDistributor()
          );
        }
      );
    })
    .catch((err) => {
      console.log(err);
    });
};


  AddDistributor = () => {
    this.setState(
      {
        showErrorMessage: true,
      },
      () => {
        this.fetchError((e) => {
          if (e === "NoError") {
            this.setState(
              {
                loader: true,
              },
              () => this.AddingDistributor(),
            );
          }
        });
      },
    );
  };

  AddAnotherDistributor = () => {
    this.setState(
      {
        showErrorMessage: true,
      },
      () => {
        this.fetchError((e) => {
          if (e === "NoError") {
            this.setState(
              {
                loader: true,
              },
              () => this.AddingAnotherDistributor(),
            );
          }
        });
      },
    );
  };

  checkDistributorUsername = (e) => {
    let data = "";
    this.state.siData.forEach((e) => {
      if (e.si_name === this.state.SiName) {
        data = "username exist";
      }
    });
    if (data === "username exist") {
      this.setState({
        usernameAvailable: false,
      });
    }
  };

  fetchError = (noError) => {
    let totalError = 0;

    const {
      SiName,
      SiEmail,
      SiMobile,
      SiAddress,
      SiArea,
      DistributorCountry,
      SiGST,
      showIndiaFields,
    } = this.state;

    if (ErrorText("notEmpty", SiName) !== "No Error") totalError++;
    if (ErrorText("email", SiEmail) !== "No Error") totalError++;
    if (ErrorText("isMobile", SiMobile) !== "No Error") totalError++;
    if (ErrorText("notEmpty", SiAddress) !== "No Error") totalError++;
    if (ErrorText("notEmpty", DistributorCountry) !== "No Error") totalError++;

    if (showIndiaFields) {
      if (ErrorText("notEmpty", SiArea) !== "No Error") totalError++;
      if (ErrorText("gst", SiGST) !== "No Error") totalError++;
    }

    if (totalError === 0) {
      noError("NoError");
    }
  };

  handleChangeInputBox = (name, event) => {
    this.setState(
      {
        [name]: event,
      },
      () => {
        if (true) {
          this.checkDistributorUsername();
        }
      },
    );
  };
  render() {
    return (
      <React.Fragment>
        <SnackBar
          open={this.state.snackbarActive}
          handleSnackbarClose={() => {
            this.setState({
              snackbarActive: false,
            });
          }}
          message={this.state.snackbarMessage}
        />
        {this.state.loader ? <Loader /> : null}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas fa-timess fa-2x mr-2"></i>
            </div>
          </div>
          <h3
            className="modal-heading text-uppercase mb-0"
            style={{ color: "#888888", fontSize: "30px" }}
          >
            Add Distributor
          </h3>
          <div className="row">
            {this.state.addAnotherSuccess ? (
              <div
                class="col-12 my-2 alert alert-success fade show"
                role="alert"
              >
                Successfully registered the Distributor.
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            ) : null}
          </div>
          <div className="row">
            <div
              className="col-6"
              style={{
                paddingLeft: "15px",
                paddingRight: "5px",
                marginTop: "13.5px",
              }}
            >
              <TextField
                label="Distributor Name"
                variant="standard"
                fullWidth
                // placeholder="Distributor Name"
                value={this.state.SiName}
                onChange={(e) => {
                  const input = e.target.value;
                  const filtered = input
                    .replace(/[^a-zA-Z ]/g, "")
                    .slice(0, 30); // Only letters and spaces
                  this.setState({ SiName: filtered });
                }}
                onPaste={(e) => {
                  const pasteData = e.clipboardData.getData("text");
                  if (!/^[a-zA-Z ]+$/.test(pasteData)) {
                    e.preventDefault(); // block invalid paste
                  }
                }}
                error={
                  ErrorText("notEmpty", this.state.SiName) !== "No Error" &&
                  this.state.showErrorMessage
                }
                helperText={
                  ErrorText("notEmpty", this.state.SiName) !== "No Error" &&
                  this.state.showErrorMessage
                    ? "Please enter the Distributor Name"
                    : ""
                }
                inputProps={{
                  maxLength: 30,
                  inputMode: "text",
                  pattern: "[A-Za-z ]*",
                }}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div
              className="col-6 text-field-modal"
              style={{
                paddingLeft: "9px",
                paddingRight: "5px",
                marginTop: "13.5px",
              }}
            >
              <TextField
                select
                variant="standard"
                fullWidth
                label="Distributor Country"
                value={this.state.DistributorCountry || ""} // should exactly match one of MenuItem values
                onChange={(e) => {
                  // console.log("Selected:", e.target.value,); // e.g. "Delhi"
                  this.onSelectChange("distributorCountry", e.target.value);
                }}
                error={
                  this.state.DistributorCountry === "" &&
                  this.state.showErrorMessage
                }
                helperText={
                  this.state.DistributorCountry === "" &&
                  this.state.showErrorMessage
                    ? "Please select the Distributor Country"
                    : ""
                }
              >
                <MenuItem value="" disabled>
                  Select Distributor Country
                </MenuItem>
                {distributorCountry.map((option, index) => (
                  <MenuItem key={index} value={option.label}>
                    {option.imageSrc && (
                      <img
                        src={option.imageSrc}
                        alt={option.label}
                        style={{
                          width: "20px",
                          height: "15px",
                          marginRight: "8px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            {this.state.showIndiaFields && (
              <div
                className="col-6   text-field-modal"
                style={{ marginTop: "13.5px", paddingLeft: "9px" }}
              >
                <TextField
                  select
                  variant="standard"
                  fullWidth
                  label="Distributor Area"
                  value={this.state.SiArea || ""} // should exactly match one of MenuItem values
                  onChange={(e) => {
                    // console.log("Selected:", e.target.value,); // e.g. "Delhi"
                    this.onSelectChange("siArea", e.target.value);
                  }}
                  error={
                    this.state.SiArea === "" && this.state.showErrorMessage
                  }
                  helperText={
                    this.state.SiArea === "" && this.state.showErrorMessage
                      ? "Please select the Distributor Area"
                      : ""
                  }
                >
                  <MenuItem value="" disabled>
                    Select Distributor Area
                  </MenuItem>
                  {this.state.indianCityWithState.map((option, index) => (
                    <MenuItem key={index} value={option.label}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}

            <div className="col-6" style={{ paddingLeft: "7px" }}>
              <InputBox
                inputText={this.state.SiAddress}
                error={
                  ErrorText("notEmpty", this.state.SiAddress) !== "No Error" &&
                  this.state.showErrorMessage
                    ? true
                    : false
                }
                errorText={
                  ErrorText("notEmpty", this.state.SiAddress) !== "No Error" &&
                  this.state.showErrorMessage
                    ? "Please enter the Distributor Address"
                    : ""
                }
                placeholder="Distributor Address"
                inputBoxName="SiAddress"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={255}
                validate={true}
                blockSpecialChar={false} // ✅ prevent special char input
              />
            </div>
            <div className="col-6" style={{ paddingLeft: "7px" }}>
              <InputBox
                inputText={this.state.SiEmail}
                error={
                  ErrorText("email", this.state.SiEmail) !== "No Error" &&
                  this.state.showErrorMessage
                    ? true
                    : false
                }
                errorText={
                  ErrorText("email", this.state.SiEmail) !== "No Error" &&
                  this.state.showErrorMessage
                    ? "Please enter a valid Distributor Email"
                    : ""
                }
                placeholder="Distributor Email"
                inputBoxName="SiEmail"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={255}
                blockSpecialChar={false} // ✅ prevent special char input
              />
            </div>

            {this.state.showIndiaFields && (
              <div className="col-6 px-0" style={{ marginTop: "1px" }}>
                <InputBox
                  inputText={this.state.SiGST}
                  error={
                    ErrorText("gst", this.state.SiGST) !== "No Error" &&
                    this.state.showErrorMessage
                      ? true
                      : false
                  }
                  errorText={
                    ErrorText("gst", this.state.SiGST) !== "No Error" &&
                    this.state.showErrorMessage
                      ? "Please enter a valid Distributor GST of 15 characters in format of 29ABCDE1234F2Z5"
                      : ""
                  }
                  placeholder="Distributor GST"
                  inputBoxName="SiGST"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={15}
                  validate={true}
                  isUppercase={true}
                />
              </div>
            )}
            <div className="col-6" style={{ paddingLeft: "7px" }}>
              <InputBox
                inputText={this.state.SiMobile}
                error={
                  ErrorText("isMobile", this.state.SiMobile) !== "No Error" &&
                  this.state.showErrorMessage
                    ? true
                    : false
                }
                errorText={
                  ErrorText("isMobile", this.state.SiMobile) !== "No Error" &&
                  this.state.showErrorMessage
                    ? "Please enter a valid Distributor Mobile of 6-15 digits"
                    : ""
                }
                isNumber={true}
                placeholder="Distributor Mobile Number"
                inputBoxName="SiMobile"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={15}
                validate={true}
              />
            </div>

            <div className="col-6 mx-0 px-0 ">
              <InputBox
                inputText={this.state.SiCompany}
                error={
                  ErrorText("notEmpty", this.state.SiCompany) !== "No Error" &&
                  this.state.showErrorMessage
                    ? true
                    : false
                }
                errorText={
                  ErrorText("notEmpty", this.state.SiCompany) !== "No Error" &&
                  this.state.showErrorMessage
                    ? "Please enter the Distributor Company"
                    : ""
                }
                placeholder="Distributor Company"
                inputBoxName="SiCompany"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={100}
                validate={true}
                blockSpecialChar={false} // ✅ prevent special char input
              />
            </div>
          </div>
          <div
            className="float-right"
            style={{ marginTop: "70px", marginRight: "-15px" }}
          >
            <div
              className="btn btn-new-grey"
              style={{ marginRight: "15px" }}
              onClick={this.closeModal}
            >
              Cancel
            </div>
            <div
              className="btn btn-new-orange"
              style={{ marginRight: "15px" }}
              onClick={this.AddAnotherDistributor.bind(this)}
            >
              Add Another
            </div>
            <i className="fa fa-star-christmas fa-spin"></i>
            <div
              className="btn btn-new-green "
              onClick={this.AddDistributor.bind(this)}
            >
              Add
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div
              className="float-right cross-times"
              onClick={this.closeModalSuccess}
            >
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">
              Distributor Added Successfully
            </h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn btn-new-grey" onClick={this.closeModalSuccess}>
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
